import React from 'react';
import { Star } from 'lucide-react';
export const SocialProofBar: React.FC = () => {
  return <div className="w-full bg-cyan-900 py-4 px-4" data-id="element-196">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-white" data-id="element-197">
        <div className="flex items-center gap-2" data-id="element-198">
          <div className="flex -space-x-2" data-id="element-199">
            {[1, 2, 3, 4].map(i => <div key={i} className="w-8 h-8 rounded-full bg-slate-300 border-2 border-cyan-900 overflow-hidden" data-id="element-200">
                <img src={`https://i.pravatar.cc/100?img=${i + 10}`} alt="Estudiante" className="w-full h-full object-cover" data-id="element-201" />
              </div>)}
          </div>
          <span className="font-semibold text-sm sm:text-base ml-2" data-id="element-202">
            +587 instrumentistas ya confían en el atlas
          </span>
        </div>

        <div className="hidden sm:block w-px h-6 bg-cyan-700" data-id="element-203"></div>

        <div className="flex items-center gap-2" data-id="element-204">
          <div className="flex" data-id="element-205">
            {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-206" />)}
          </div>
          <span className="font-bold text-lg" data-id="element-207">4.8/5.0</span>
        </div>
      </div>
    </div>;
};